import { Reducer, Action } from "redux";
import { IBillingStatusState, KnownAction, RESET_FOR_BILLING_STATUS, GET_BILLING_STATUS, LOADER_FOR_BILLING_STATUS } from "./types";

export const reducer: Reducer<IBillingStatusState> = (state: IBillingStatusState | undefined, incomingAction: Action): IBillingStatusState => {
    if (state === undefined) {
        return { billingStatus: false, isBillingStatusLoaded: false };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case GET_BILLING_STATUS:
            return {
                ...state,
                billingStatus: action.billingStatus,
            };
        case LOADER_FOR_BILLING_STATUS:
            return {
                ...state,
                isBillingStatusLoaded: action.isBillingStatusLoaded,
            };
        case RESET_FOR_BILLING_STATUS:
            return {
                ...state,
                isBillingStatusLoaded: false,
                billingStatus: false,
            };
        default:
            return state;
    }
};
